var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUpArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 5,
    viewBox: "0 0 8 5",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.31098 0.132586L7.87126 3.79934C8.04291 3.97612 8.04291 4.2629 7.87126 4.43968L7.45595 4.86739C7.28447 5.04398 7.00674 5.04417 6.8349 4.86814L4.00009 1.9621L1.1651 4.86796C0.993256 5.04417 0.715527 5.04379 0.544053 4.8672L0.128743 4.43949C-0.0429146 4.26271 -0.0429146 3.97594 0.128743 3.79915L3.6892 0.132586C3.86086 -0.0441956 4.13932 -0.0441956 4.31098 0.132586Z",
    fill: "#545454"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpArrow);
export default __webpack_public_path__ + "static/media/upArrow.54434fc686d199ed300c24be0e6f985c.svg";
export { ForwardRef as ReactComponent };